package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.domain.repository.SubscriptionRepository
import com.clany.backoffice.model.SubscriptionResponse
import com.clany.backoffice.model.UpdateSubscriptionPlanRequest
import io.ktor.client.request.parameter
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.HttpMethod
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.ContributesBinding
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class SubscriptionRepositoryImpl(
    private val networkClient: NetworkClient
) : SubscriptionRepository {

    private val baseUrl = KeycloakConfig.API_URL

    override suspend fun getSubscriptions(page: Int, pageSize: Int, query: String?): Result<List<SubscriptionResponse>> {
        return networkClient.request<List<SubscriptionResponse>>("$baseUrl/api/subscriptions") {
            parameter("page", page)
            parameter("limit", pageSize)
            if (query != null) parameter("q", query)
        }
    }

    override suspend fun updatePlan(id: String, request: UpdateSubscriptionPlanRequest): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/subscriptions/$id/plan", HttpMethod.Patch, request) {
            contentType(ContentType.Application.Json)
        }
    }
}
